import React from "react";
import { Result, Button } from "antd";

/**
 * ErrorBoundary — catches unhandled JS errors in child component tree.
 * Without this, a single crash (e.g. undefined.map()) blanks the entire page.
 * With this, only the crashed section shows an error message with a retry button.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log to console in development only
    if (process.env.NODE_ENV === "development") {
      console.error("[ErrorBoundary]", error, errorInfo);
    }
    // TODO: Send to error tracking service (Sentry, LogRocket, etc.)
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 48, display: "flex", justifyContent: "center", alignItems: "center", minHeight: 300 }}>
          <Result
            status="error"
            title="Có lỗi xảy ra"
            subTitle="Trang gặp sự cố. Vui lòng thử tải lại."
            extra={[
              <Button key="retry" type="primary" onClick={this.handleRetry}>
                Thử lại
              </Button>,
              <Button key="home" onClick={() => window.location.assign("/")}>
                Về trang chủ
              </Button>,
            ]}
          />
        </div>
      );
    }

    return this.props.children;
  }
}
